<template>
  <div class="tourist_region_modal_content">
    <div class="row" v-if="touristRegion !== null">

      <div class="col-12 col-lg-4">
        <ClientOnly>
          <Image_slider :images="touristRegion.images" :options="{}"/>
        </ClientOnly>
      </div>
      <div class="col-12 col-lg-8 d-flex justify-content-center align-items-center">
        <div class="region-content row">
          <div class="col">
            <h2 class="h2 second-color">
              <TyIcon icon="ty-region-3" width="3rem" class="pe-2 icon-color-second"/>
              {{ touristRegion.title }}
            </h2>
            <p class="mb-3">{{ touristRegion.langdescription[activeLocale.code] ? touristRegion.langdescription[activeLocale.code] : touristRegion.description }}</p>

            <p v-if="touristRegionUrl">
              <NuxtLink :to="`/${touristRegionUrl}`" class="btn btn-outline-first rounded" @click="emit('hideModal')">
                {{ $t('show-more') }}
              </NuxtLink>
            </p>
          </div>
        </div>
      </div>
      <div class="col-12 mt-lg-4" v-if="touristRegion.attractions.length > 0">
        <hr>

        <h3 class="h3 text-capitalize second-color mb-3">
          <TyIcon icon="ty-city-3" height="2.5rem" class="pe-2 icon-color-second"/>
          {{ $t('attractions') }}
        </h3>
        <div class="row">
          <div class="col-12 col-lg-6 col-xxl-4 mb-4 tourist_region_modal_content" v-for="attraction in touristRegion.attractions">
            <div class="row">
              <div class="col-12">
                <figure class="attraction-photo_small mb-3" v-if="attraction.hasImage()">
                  <picture>
                    <PartsSrcSetImage :image="attraction.getTopImage()" :t_type="'thumbw'" :type="'webp'"/>
                    <PartsSrcSetImage :image="attraction.getTopImage()" :t_type="'thumbw'" :type="'jpeg'"/>

                    <img :src="attraction.getTopImage().getTyrionSrc('thumbw')" :alt="touristRegion.attractions.title" class="img-cover" loading="lazy">

                  </picture>
                </figure>
                <figure v-else class="attraction-photo_small mb-3">
                  <img src="~/assets/img/blank.jpg" :alt="touristRegion.attractions.title" class="img-cover" loading="lazy"
                       width="600" height="337">
                </figure>
              </div>
              <div class="col-12">
                <h4 class="h4">{{ attraction.title }}</h4>
              </div>
              <div class="col-12 ">
                <p class="description-text"
                   v-if="typeof attraction.description === 'object' && attraction.description[activeLocale.code] !== undefined">
                  {{ attraction.description[activeLocale.code].substr(0, 250) }}...
                </p>
                <NuxtLink v-if="attractionUrl(attraction).length > 0" :to="attractionUrl(attraction)"
                          class="btn btn-outline-first rounded"
                          target="_blank">{{ $t('show-more') }}
                </NuxtLink>

              </div>

            </div>


          </div>
        </div>
      </div>
    </div>
    <PartsTempPreloader v-else/>

    <div class="alert alert-danger mt-4" v-if="tyrionResponseStatus && tyrionResponseStatus.status === 'error'">
      {{ tyrionResponseStatus.msg }}
    </div>
  </div>
</template>

<script setup lang="ts">
import {tyrionResponse} from "~/composables/tyrionResponse";
import {computed, onMounted, PropType, ref} from "vue";
import {obtainActiveLocale} from "~/composables/master_page";
import PlaceTouristRegion from "~/lib/models/PlaceTouristRegion";
import PlaceAttraction from "../../../../../lib/models/PlaceAttraction";
import {useNuxtApp} from "#app";
import {resolveComponent} from "#imports";

const Image_slider = resolveComponent("LazyPartsUniImageSlider");
const {setTyrionResponseStatus, tyrionResponseStatus} = tyrionResponse();

const props = defineProps({
  region_id: Number,
});

const emit = defineEmits(['hideModal']);

const {$tyrionApi} = useNuxtApp();
const activeLocale = obtainActiveLocale();
const touristRegion = ref<PlaceTouristRegion | null>(null);
const loading = ref(true);

const touristRegionUrl = computed(() => {
  if (touristRegion.value && (typeof touristRegion.value.page_urls === 'object') && touristRegion.value.page_urls[activeLocale.code] !== undefined) {
    return touristRegion.value.page_urls[activeLocale.code];
  } else {
    return null;
  }
})

onMounted(() => {
  loadTouristRegion();
});

const loadTouristRegion = () => {
  $tyrionApi.getTyrionUrl(`/api3/tourist_region/${props.region_id}.sle3.json`).then(res => {
    touristRegion.value = (new PlaceTouristRegion()).fromObject(res.data);
  }).catch((e) => {
    setTyrionResponseStatus('error', (e.response && e.response.data && e.response.data.message) ? e.response.data.message : `Chat error: ${e.message}`);
  })
};

const attractionUrl = (attraction: PlaceAttraction) => {
  return typeof attraction.page_urls === 'object' && attraction.page_urls[activeLocale.code] !== undefined ? `/${attraction.page_urls[activeLocale.code]}` : '';
}
</script>
